import { render, staticRenderFns } from "./UserTariffDialog.vue?vue&type=template&id=6afab99f&scoped=true&"
import script from "./UserTariffDialog.vue?vue&type=script&lang=ts&"
export * from "./UserTariffDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afab99f",
  null
  
)

export default component.exports